import type { AppDef } from '../../types/window';
import { aboutApp } from './AboutApp';
import { projectsApp } from './ProjectsApp';
import { gamesApp } from './GamesApp';
import { musicApp } from './MusicApp';
import { notepadApp } from './NotepadApp';
import { browserApp } from './BrowserApp';
import { wrackApp } from './WrackLoreApp';
import { controlPanelApp } from './ControlPanelApp';
import { displayApp } from './DisplayApp';
import { soundsApp } from './SoundsApp';
import { videosApp } from './VideosApp';

export const APPS: Record<string, AppDef> = {
  about: aboutApp,
  projects: projectsApp,
  games: gamesApp,
  music: musicApp,
  notepad: notepadApp,
  browser: browserApp,
  wrack: wrackApp,
  control: controlPanelApp,
  display: displayApp,
  sounds: soundsApp,
  videos: videosApp,
};
